import { Feature } from '@getstep/proto/feature';
import { observer } from 'mobx-react';
import { PublicProfile } from '../../../components/public-profile';
import type { ActionProps } from '../../../contentful-components/action-button';
import type { PageMetaFragment } from '../../../graphql/fragments/PageMetaFragment.graphql';
import { AssetTag, useRandomVideos } from '../../../graphql/hooks/video';
import { PersonalizationProvider } from '../../../lib/hooks/usePersonalizations';
import { useOverrideFeature } from '../../../lib/store/feature/useOverrideFeature';
import type { PublicProfileState } from '../../../lib/store/PublicProfilePageStore';
import type { PageWithContext } from '../../../lib/utils/context';
import { PAGE_OPTIONS } from '../../../lib/utils/page';
import { TEXT } from '../../../lib/utils/text';
import { PageTemplate } from '../../../page-templates/generic-page';
import { LINK } from '../../../shared/util/link';

/**
 * User's public profile page.
 */
const Profile: PageWithContext<Props> = observer(({
  profile,
  page
}) => {
  const {
    videos
  } = useRandomVideos([AssetTag.PayMePage]);
  if (!profile) {
    return null;
  }
  const {
    username,
    displayName = '',
    pictureUrl,
    hasPublicPayLink
  } = profile;
  const personalizations = {
    username,
    displayName,
    pictureUrl
  };
  useOverrideFeature(Feature.PUBLIC_PAY_ME_LINK, !!hasPublicPayLink);
  const primaryButton: ActionProps = username && hasPublicPayLink ? {
    title: TEXT.payUserWithCard,
    type: 'LocalPathnameAction',
    path: LINK.profilePay(username).serialize(),
    analyticsKey: 'pay-me-card-button',
    'data-testid': 'pay.withCardButton'
  } : {
    title: TEXT.sendMoneyOnStep,
    type: 'ActionDownloadApp',
    analyticsKey: 'send-money-on-step'
  };
  return <PersonalizationProvider value={personalizations}>
            <PublicProfile {...profile} username={username} primary={primaryButton} videos={videos} layout='fluid' />
            <PageTemplate {...PAGE_OPTIONS.USER} pageData={page} includeBanner={false} meta={{
      ...PAGE_OPTIONS.USER.meta,
      ogImage: username ? LINK.qrcode(username, 'png') : undefined
    }} />
        </PersonalizationProvider>;
});
export { getServerSideProps } from '../../../server/helpers/profile';
export default Profile;
interface Props {
  profile: PublicProfileState;
  page: PageMetaFragment;
}